// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__sL3Sv","label":"CategoryService_label__3ynxC","location":"CategoryService_location__3Q6gf"};